<template>
  <div class="wrapper">
    <el-container class="indexcontainer">
      <el-header>
        <div class="headBox">
          <img
            class="admin-logo"
            src="../../image/logo/sys-logo.png"
            alt=""
          />
          <p class="company-name">{{ companyName }}</p>
          <el-dropdown
            class="avatar-container right-menu hover-effect"
            trigger="hover"
          >
            <div class="avatar-wrapper">
              <img
                src="./../../image/logo/admin_index.png"
                class="user-avatar"
              />
              <span class="user-name">{{ userName }}</span>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="outlogin">
                <span>退出登录</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <div class="btn-fullscreen" @click="handleFullScreen">
            <span
              :class="[
                isFullscreen ? 'icon-fullscreen' : 'icon-exit-fullscreen',
                'iconfont',
                'screenicon',
              ]"
            >
            </span>
          </div>
        </div>
      </el-header>

      <el-container>
        <el-aside :width="isCollapse ? '64px' : '200px'">
          <div class="toggle-button" @click="toggleCollapse">|||</div>
          <el-menu
            @select="handleSelect"
            :default-active="$route.path"
            background-color="#333744"
            text-color="#fff"
            active-text-color="#409EFF"
            unique-opened
            :collapse="isCollapse"
            :collapse-transition="false"
            router
          >
            <el-menu-item :index="'/user/home/homeindex'" class="home-index">
              <i class="iconfont icon-index"></i>
              <span slot="title">首页</span>
            </el-menu-item>
            <el-submenu
              :index="item.id + ''"
              v-for="item in menuList"
              :key="item.id"
              class="menu-list"
            >
              <template slot="title">
                <i :class="['iconfont', item.iconUrl]"></i>
                <span>{{ item.title }}</span>
              </template>

              <el-menu-item
                v-for="subItem in item.children"
                :index="'/user/home/' + subItem.linkUrl"
                :key="subItem.id"
              >
                <template slot="title">
                  <span>{{ subItem.title }}</span>
                </template>
              </el-menu-item>
            </el-submenu>
          </el-menu>
        </el-aside>
        <el-main :class="{ main_conainer: isCollapse }">
          <div
            class="tags-view-box"
            :style="{ left: isCollapse ? '64px' : '200px' }"
          >
            <TagsView />
          </div>
          <section class="app-main">
            <transition name="fade-transform" mode="out-in">
              <router-view></router-view>
            </transition>
          </section>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import "../../assets/icons/iconfont.css";
import {
} from "@/common/api.js";
import { TagsView } from "../../components/TagsView";
import { mapState } from "vuex";
import screenfull from "screenfull";

export default {
  components: {},
  props: {},
  data() {
    return {
      userName: "",
      companyName: "",
      level1Menu: [],
      isshowHeader: false,
      isFullscreen: false,
      isCollapse: true,
      isshowimg: true,
      tagesList: [],
      menuList: [],
      isCollapse: false,
      // 被激活的链接地址
      activePath: "",
    };
  },
  watch: {
    // $route(to, from) {
    //   var path = to.path;
    //   if (path != "/admin/audit") {
    //     this.isshowimg = false;
    //   } else {
    //     this.isshowimg = true;
    //   }
    // },
  },
  computed: {
    ...mapState({
      sidebar: (state) => state.app.sidebar,
      device: (state) => state.app.device,
      showSettings: (state) => state.settings.showSettings,
      needTagsView: (state) => state.settings.tagsView,
      fixedHeader: (state) => state.settings.fixedHeader,
    }),
  },
  methods: {
    // 获取导航菜单
    // queryCompanyUserMenus() {
    //   queryCompanyUserMenus().then((res) => {
    //     console.log("res :>> ", res);
    //     if (res.errorCode == 200) {
    //       console.log(res.companyNavigationPer);
    //       if (res.companyNavigationPer) {
    //         this.menuList = res.companyNavigationPer.children;
    //         this.level1Menu = res.systemNavigations;
    //         this.$store.dispatch("getlevel1Menu", this.level1Menu);
    //       }
    //     } else {
    //       this.$message.error(res.msg);
    //     }
    //   });
    // },
    handleSelect(key, keyPath) {
      // console.log(this.$store.state);
    },
    toggleCollapse() {
      this.isCollapse = !this.isCollapse;
    },
    addtags(name) {
      // console.log("name :>> ", name);
    },
    removeTages(index) {
      this.tagesList.splice(index, 1);
    },
    goindex() {
      this.$router.push({
        path: "/admin/index",
      });
    },
    outlogin() {
      this.$confirm("确认要退出系统吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          window.sessionStorage.removeItem("token");
          sessionStorage.clear();
          this.$store.dispatch("tagsView/logoutSystemView", []);
          this.$router.push({
            path: "/login",
          });
        })
        .catch((e) => e);
    },
    handleFullScreen() {
      if (!screenfull.isEnabled) {
        this.$message({
          message: "不支持全屏",
          type: "warning",
        });
        return false;
      }
      screenfull.toggle();
      this.isFullscreen = !this.isFullscreen;
    },

    change() {
      this.isFullscreen = screenfull.isFullscreen;
    },
    init() {
      if (screenfull.isEnabled) {
        screenfull.on("change", this.change);
      }
    },
    destroy() {
      if (screenfull.isEnabled) {
        screenfull.off("change", this.change);
      }
    },
  },
  created() {
    this.menuList = JSON.parse(window.sessionStorage.getItem("routerList"));
  },
  mounted() {
    this.init();
    var id = this.$store.state.id;
    if (id) {
      this.isshow = id;
    }
    var contactPerson = window.sessionStorage.getItem("contactPerson");
    if (contactPerson == "null") {
      this.userName = window.sessionStorage.getItem("userName");
    } else {
      this.userName = contactPerson;
    }
    this.companyName = window.sessionStorage.getItem("companyName");
  },
};
</script>
<style lang="less" scoped>
.app-main {
  /* 50= navbar  50  */
  height: 100%;
  position: relative;
}

.fixed-header + .app-main {
  padding-top: 50px;
}

.wrapper {
  width: 100%;
  height: 100%;
  /deep/.el-input.is-disabled .el-input__inner,
  /deep/.el-textarea.is-disabled .el-textarea__inner {
    color: #777777;
  }
  /deep/ .el-table th {
    background-color: #f5f5f6 !important;
    color: #676a6c;
    border-bottom: 1px solid #ccc;
  }

  /deep/.el-table__fixed,
  /deep/.el-table__fixed-right {
    height: 100% !important;
  }
  // /deep/.el-table .cell {
  //   white-space: nowrap !important;
  // }
  /deep/.el-icon-circle-close:before {
    color: #ffffff !important;
  }
  .indexcontainer {
    width: 100%;
    height: 100%;
    .el-header {
      position: fixed;
      z-index: 99;
      width: 100%;
      background-color: #4e97d9;
      height: 60px !important;
      padding: 0 !important;
      // line-height: 88px;
      img.admin-logo {
        // width: 220px;
        height: 40px;
        margin-top: 10px;
        margin-left: 30px;
      }
      .headBox {
        position: relative;
        height: 60px;
        width: 100%;
        line-height: 60px;
        .btn-fullscreen {
          float: right;
          .iconfont {
            margin-right: 10px;
            cursor: pointer;
          }
        }
        .company-name {
          position: absolute;
          left: 50%;
          top: 0;
          color: #ffffff;
          font-weight: bold;
        }
        .right-menu {
          float: right;
          height: 100%;
          line-height: 60px;
        }
        .avatar-container {
          margin-right: 30px;
          .avatar-wrapper {
            position: relative;
            .user-avatar {
              cursor: pointer;
              width: 40px;
              height: 40px;
              margin-top: 10px;
              border-radius: 50%;
              vertical-align: top;
            }
            .user-name {
              float: right;
              margin-left: 10px;
              color: #ffffff;
              font-size: 14px;
              font-weight: 600;
            }
            .el-icon-caret-bottom {
              cursor: pointer;
              position: absolute;
              right: -20px;
              top: 35px;
              font-size: 16px;
            }
          }
        }
      }
    }
    .el-main {
      margin-left: 200px;
      margin-top: 60px;
      height: calc(100% - 60px);
      overflow: hidden;
      padding-top: 40px;
    }
    .main_conainer {
      margin-left: 64px;
    }
    aside.el-aside::-webkit-scrollbar {
      width: 0;
    }
    .el-aside {
      position: fixed;
      z-index: 9;
      height: calc(100% - 60px);
      margin-top: 60px;
      background-color: #333744;
      .toggle-button {
        background-color: #4a5064;
        font-size: 10px;
        line-height: 24px;
        color: #fff;
        text-align: center;
        letter-spacing: 0.2em;
        cursor: pointer;
      }
      .el-menu {
        border-right: none;
      }
      .navtages {
        height: 56px;
        max-width: 160px;
        line-height: 56px;
        color: #ffffff;
        padding: 0 20px;
        cursor: pointer;
        i {
          font-size: 18px;
          margin-right: 10px;
          color: #a7b1c2;
        }
        span {
          font-size: 14px;
        }
      }
    }
    .banner {
      width: 100%;
      text-align: center;
      img {
        width: 80%;
        margin-top: 10px;
      }
    }
    .home-index {
      .el-icon-s-home {
        width: auto;
      }
    }
    .iconfont {
      font-size: 14px;
      margin-right: 10px;
      color: #a7b1c2;
    }
    .screenicon {
      font-size: 24px;
      color: #fff;
    }
    .el-menu-item {
      color: #a7b1c2 !important;
    }
    .el-menu-item.is-active {
      color: #ffffff !important;
      background-color: #1890ff !important;
    }
    .el-submenu .el-menu-item {
      height: 36px !important;
      line-height: 36px !important;
    }
  }
  /deep/.el-image-viewer__close {
    color: #ffffff;
  }
  /deep/.el-pagination {
    text-align: right;
    background-color: #fff;
    padding: 20px 10px;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
  }
  /deep/.cell .el-button--mini {
    padding: 0 8px;
    height: 24px;
    line-height: 24px;
    margin-left: 6px;
  }
  /deep/.el-dialog__header {
    padding-top: 10px;
    background: #f8f8f8;
    border-bottom: 1px solid #ddd;
    .el-dialog__title {
      font-size: 16px;
    }
    .el-dialog__headerbtn {
      top: 10px;
    }
  }
  /deep/.el-dialog__footer {
    padding-bottom: 10px;
    background: #f8f8f8;
    border-top: 1px solid #ddd;
    .el-button {
      padding: 10px 15px;
    }
  }

  /* button color */
  /deep/.el-button--cyan.is-active,
  .el-button--cyan:active {
    background: #20b2aa;
    border-color: #20b2aa;
    color: #ffffff;
  }

  /deep/.el-button--cyan:focus,
  /deep/.el-button--cyan:hover {
    background: #48d1cc;
    border-color: #48d1cc;
    color: #ffffff;
  }

  /deep/.el-button--cyan {
    background-color: #20b2aa;
    border-color: #20b2aa;
    color: #ffffff;
  }
  .tags-view-box {
    position: fixed;
    top: 60px;
    right: 0;
    height: 40px;
    z-index: 99;
  }
}
</style>


// WEBPACK FOOTER //
// src/view/user/home.vue